import React from "react";
import { useLocation } from "react-router-dom";
const adminEmail = sessionStorage.getItem('userEmail');

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

function DetailsQR() {
    const query = useQuery();

    const orderNo = query.get("orderNo");
    const compName = query.get("compName");
    const recName = query.get("recName");
    const recAdd = query.get("recAdd");
    const amount = query.get("amount");
    const distance = query.get("distance");
    const oTime = query.get("oTime");
    const pickTime = query.get("pickTime");
    const delTime = query.get("delTime");

    return (
        <div>
            <h1>Order Details</h1>
            <p>Order No: {orderNo}</p>
            <p>Company Name: {compName}</p>
            <p>Recipient Name: {recName}</p>
            <p>Recipient Address: {recAdd}</p>
            <p>Amount: ₹ {amount}</p>
            <p>Distance: {distance}</p>
            <p>Order Time: {oTime}</p>
            <p>Pickup Time: {pickTime}</p>
            <p>Delivery Time: {delTime}</p>
            <p>AdminEmail: {adminEmail}</p>
        </div>
    );
}

export default DetailsQR;
